import './App.css';
import React from 'react';
import Map from './Map';
import Selected from './Selected'
import Sidebar from './Sidebar'
import Infopane from './Infopane'
import Geolocate from './Geolocate'
import { Layout, Card } from 'antd';

function App() {
  const [ userLoc, setUserLoc ] = React.useState({ showLoc: false });
  const [ showing, setShowing ] = React.useState({ crimejunkie: true });
  const [ cardData, setCardData ] = React.useState({});
  const [ showCard, setShowCard ] = React.useState(false);

  return (
    <Layout>
      <div style={{ position: "relative", width: '100vw', height: '100vh' }}>
        <Map 
          {...showing}
          setCardData={setCardData}
          setShowCard={setShowCard}
          userLoc={userLoc}
        />

        <div style={{ position: "absolute", top: "20px", left: "20px" }}>
          <Selected width="35vw" setShowing={setShowing} />
        </div>

        {showCard && 
          <Infopane cardData={cardData} showCard={showCard} setShowCard={setShowCard} />
        }
        <div style={{ position: "absolute", top: "20px", right: "20px" }}>
          <Geolocate setUserLoc={setUserLoc} />
        </div>
      </div>

    </Layout>

  );

}



export default App;
